import * as React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import DesktopLayout from 'shared/components/layout/DesktopLayout';
import CourseListPage from './CourseList/CourseListPage';
import CartPage from './Cart/CartPage';
import ProfilePage from './Profile/ProfilePage';
import CoursesPage from "./Courses/CoursesPage";
import CourseForm from "./Courses/CourseForm";
import AddCourseForm from "./Courses/AddCourseForm";
import CourseView from "./Courses/CourseView";
import CurriculumForm from "./Curriculums/CurriculumForm";
import CurriculumView from "./Curriculums/CurriculumView";
import MeetingForm from "./Meetings/MeetingForm";
import QuestionForm from "./Questions/QuestionForm";
import ContentForm from "./Contents/ContentForm";
import ContentView from "./Contents/ContentView";
import AllCoursesList from "./AllCourses/AllCoursesList"
import SingleCourseDetail from "./AllCourses/SingleCourseDetail"
import MyCourses from './MyCourses/MyCourses';
import MyCoursesDetails from './MyCourses/MyCoursesDetails';
import ContentList from './Courses/ContentList';
import FrontendMyCourse from './FrontendMyCourse/FrontendMyCourse';
import FrontendUpcommingMeetings from './FrontendUpcommingMeetings/FrontendUpcommingMeetings';
import FrontendInsights from './FrontendInsights/FrontendInsights';
import FrontendReviews from './FrontendReviews/FrontendReviews';
import FrontendCourseStudent from './FrontendCourseStudent/FrontendCourseStudent';
import FrontendMyBadges from './FrontendMyBadges/FrontendMyBadges';
import InsCourseReport from './InsCourseReport/InsCourseReport';
import ContentDetailsPageAdmin from './ContentDetails/ContentDetailsPageAdmin';
import UpcommingCourses from './UpcommingCourses/UpcommingCourses';
type Props = {}


const Layout: React.FunctionComponent<Props> = () => {
    const AppLayout =  DesktopLayout;
    const location = useLocation();
       
    const routesToShowButton = [
       '/my/profile',
       '/my/management/my/courses',
       '/my/management/reviews',
       '/my/management/badges',

       '/my/management/courses-report',
       '/my/management/course-student'
     ];

      const showMobileButton = routesToShowButton.includes(location.pathname);

    return (
        <AppLayout showMobileButton={showMobileButton}>
            <Switch>
                <Route exact path="/my/profile" component={ProfilePage}/>
                {/* <Route exact path="/my/cart" component={CartPage}/> */}
                <Route exact path="/my/:mode" component={CourseListPage}/>
                <Route exact path="/my/courses/:id" component={MyCoursesDetails}/>
                {/* <Route exact path="/my/management/courses" component={CoursesPage}/> */}
              {/* <Route exact path="/my/management/courses/:id/view" component={CourseView}/> */}
              {/* <Route exact path="/my/management/courses/:mode" component={CourseForm}/> */}
              {/* <Route exact path="/my/management/courses/:id/:mode" component={CourseForm}/> */}
              {/*route defined by ST start*/}
              {/* <Route exact path="/my/management/all-courses" component={AllCoursesList}/> */}
              <Route exact path="/my/management/courses/:mode" component={AddCourseForm}/>
                <Route exact path="/my/management/courses/:id/view" component={ContentList}/>
                <Route exact path="/my/management/courses/:id/edit" component={AddCourseForm}/>
                <Route exact path="/my/management/courses/:id/:mode" component={CourseForm}/>
              {/*route defined by ST end*/}


              <Route exact path="/my/management/courses/:courseId/curriculums/:mode" component={CurriculumForm}/>
              {/* <Route exact path="/my/management/courses/:courseId/curriculums/:id/view" component={CurriculumView}/> */}
              <Route exact path="/my/management/courses/:courseId/curriculums/:id/:mode" component={CurriculumForm}/>

              <Route exact path="/my/management/courses/:courseId/meetings/:mode" component={MeetingForm}/>

              <Route exact path="/my/management/my/courses" component={FrontendMyCourse}/>
              {/* <Route exact path="/my/management/upcomming-meetings" component={FrontendUpcommingMeetings}/> */}
              <Route exact path="/my/management/reviews" component={FrontendReviews}/>
              {/* <Route exact path="/my/management/orders" component={FrontendInsights}/> */}
              <Route exact path="/my/management/course-student" component={FrontendCourseStudent}/>
              <Route exact path="/my/management/course-student/:id" component={FrontendCourseStudent}/>
              <Route exact path="/my/management/courses-report" component={InsCourseReport}/>
              <Route exact path="/my/management/badges" component={FrontendMyBadges}/>

              {/* <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:contentId/questions/:mode"
                     component={QuestionForm}/>
              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:contentId/questions/:id/view"
                     component={QuestionForm}/>

              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:mode"
                     component={ContentForm}/>
              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:id/view"
                     component={ContentView}/>
              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:id/:mode"
                     component={ContentForm}/> */}
              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:contentId/questions/:id/edit"
                            component={QuestionForm}/>
              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:id/edit"
                     component={ContentView}/>
              <Route exact path="/my/management/courses/:courseId/curriculums/:curriculumId/contents/:id/view" component={ContentDetailsPageAdmin}/>
              <Route exact path="/my/management/training-schedule" component={UpcommingCourses} />
              <Route exact path="/my/:mode/courses" component={CourseListPage}/>
            </Switch>
        </AppLayout>
    );
};

export default Layout;
